
import { Component, Vue } from "vue-property-decorator";
import { Category } from "@/types/woothee_category";

@Component({})
export default class extends Vue {
  get osImgUrl(): string {
    return require("@/assets/images/common/link/link_salespartners.jpg");
  }
  get drImgUrl(): string {
    return require("@/assets/images/common/link/link_drtel.jpg");
  }
}
